<div *transloco="let t">
  @if (tabs) {
    <tabset #staticTabs>
      @for (tab of tabs; track tab) {
        <tab [disabled]="tab.disabled" [active]="tab.active" [heading]="tab.translationKey ?  t(tab.translationKey) : tab.preTranslatedText ? tab.preTranslatedText : ''" id="{{tab.id}}" (selectTab)="onSelect(tab,$event)">{{tab.content}}</tab>
      }
    </tabset>
  }
</div>